import { parseUrlHelper, useModals } from "@skailer-com/uikit";
import { TaskViewModal } from "@/pages/tasks/widgets/TaskViewModal.tsx";
import { useTask } from "@/queries/employees/use-employee-tasks.query.ts";
import { ApiTask } from "@/types/task.types.ts";
import { useEffect, useMemo, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";

export function useOpenTaskFromUrl() {
  const [searchParams] = useSearchParams();
  const { openModal } = useModals();

  const [initialTaskId] = useState(() => parseUrlHelper.getNumber(searchParams, "task_id") ?? null);
  const hasOpenedRef = useRef(false);

  const { data: taskById } = useTask(initialTaskId);

  useEffect(() => {
    if (!taskById || hasOpenedRef.current) return;
    hasOpenedRef.current = true;
    openModal(TaskViewModal, { task: taskById });
  }, [taskById]);
}

export function useTaskDueSplit(tasks: ApiTask[] | undefined) {
  const startOfToday = useMemo(() => {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  }, []);

  const overdueTasks = useMemo(
    () => tasks?.filter((task) => task.date_due && task.date_due < startOfToday) ?? [],
    [tasks, startOfToday]
  );

  const upcomingTasks = useMemo(
    () => tasks?.filter((task) => !task.date_due || task.date_due >= startOfToday) ?? [],
    [tasks, startOfToday]
  );

  return { overdueTasks, upcomingTasks };
}
